export default function ($timeout) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            'show': '=',
            'onActionClick': '&'
        },
        /* eslint-disable no-param-reassign */
        link: (scope) => {

            scope.snackBarStamp = new Date().getTime();

            let snackBarEl = null;
            let actionCallback = null;

            $timeout(() => {
                snackBarEl = mdc.snackbar.MDCSnackbar.attachTo(document.querySelector(`#element_snack_bar_${scope.snackBarStamp}`));
            });

            scope.show = (messageText, actionText, flag, actionFn = null) => {
                scope.actionButtonIsVisible = false;
                snackBarEl.labelText = messageText;
                snackBarEl.actionButtonText = actionText;
                actionCallback = actionFn;
                snackBarEl.timeoutMs = 4000;

                if (typeof actionFn === 'function') {
                    $timeout(() => {
                        snackBarEl.timeoutMs = -1; // disable autoremove
                        scope.actionButtonIsVisible = true;
                    });
                }

                if (flag) {
                    snackBarEl.open();
                } else {
                    snackBarEl.close();
                }
            };

            scope.hide = () => {
                snackBarEl.close();
            };

            scope.handleActionClick = () => {
                if (typeof actionCallback === 'function') {
                    actionCallback();
                } else {
                    console.log('No valid callback function provided.');
                }
            };
        },
        template: `<div class="mdc-snackbar dfs-snackbar" id="element_snack_bar_{{snackBarStamp}}">
                        <div class="mdc-snackbar__surface" role="status" aria-relevant="additions">
                            <div class="mdc-snackbar__label" aria-atomic="false" style="margin-top: 20px;">
                            </div>
                            <div class="mdc-snackbar__actions" aria-atomic="true" ng-show="actionButtonIsVisible">
                                <a href="javascript:void(0);" class="mdc-snackbar__action" ng-click="handleActionClick()">
                                    Action
                                </a>
                            </div>
                            <button type="button" class="mdc-icon-button close-dialog-button-light" ng-click="hide()">
                                <span class="material-icons" style="font-size: 16px;">close</span>
                            </button>
                        </div>
                    </div>`
    };
}